type OptionalString = string | null;

export interface WpAuthorship {
  bio: OptionalString;
  displayName: OptionalString;
  profilePic: OptionalString;
  teacherType: OptionalString;
  teacherUrl: OptionalString;
  type: OptionalString;
}

interface Authorship {
  name: OptionalString;
  description?: OptionalString;
  url?: OptionalString;
  image?: {
    '@type': 'ImageObject';
    url?: OptionalString;
    width?: number | null;
    height?: number | null;
  };
}

interface AuthorshipByType {
  author: Authorship | null;
  coauthor: Authorship | null;
  reviewer: Authorship | null;
}

function extractAuthorship(authorship: Array<WpAuthorship>): AuthorshipByType {
  const authorsByType = {
    author: null,
    coauthor: null,
    reviewer: null,
  };

  authorship.forEach((author: WpAuthorship) => {
    const person: Authorship = {
      name: author.displayName,
      description: author.bio,
      url: author.teacherUrl,
    };

    if (author.profilePic) {
      person.image = {
        '@type': 'ImageObject',
        url: author.profilePic,
      };
    }

    authorsByType[author.type] = { ...person };
  });

  return authorsByType;
}

function getArticleAndWebsiteIndexes(schema: object): {
  articleIndex: number;
  websiteIndex: number;
} {
  let articleIndex = -1;
  let websiteIndex = -1;

  schema['@graph'].every((item: unknown, index: number) => {
    if (item['@type'] === 'Article') {
      articleIndex = index;
    }

    if (item['@type'] === 'WebPage') {
      websiteIndex = index;
    }

    return articleIndex === -1 || websiteIndex === -1;
  });

  return { articleIndex, websiteIndex };
}

const getFullSchemaOrg = (
  schema: string | null,
  authorship: Array<WpAuthorship> | null
) => {
  if (!schema) return null;

  let newSchema = null;

  try {
    newSchema = JSON.parse(schema);

    const { author, coauthor, reviewer } = extractAuthorship(authorship);
    const mainAuthor = author || coauthor;
    const { articleIndex, websiteIndex } =
      getArticleAndWebsiteIndexes(newSchema);

    newSchema['@graph'][articleIndex].author = {
      ...mainAuthor,
      '@type': 'Person',
      ...author,
    };

    if (reviewer) {
      newSchema['@graph'][websiteIndex].reviewedBy = {
        '@type': 'Person',
        sameAs: reviewer.url,
        ...reviewer,
      };
    }
  } catch (error) {
    newSchema = null;
  }

  return newSchema;
};

export default getFullSchemaOrg;
